import React from 'react'
import styled from 'styled-components'
import { Box, Text } from 'vvs-uikit'
import { BoostPoolInfo } from 'config/constants/types'
import { formatLockPeriod } from 'views/xVvs/helpers'
import { formatNumber } from 'utils/formatBalance'
import LockPeriodLogo from '../../LockPeriodLogo'
import { useVaultsApr } from '../../../hooks/useVaultsApr'

interface LockingPeriodSelectProps extends BoostPoolInfo {
  isSelected: boolean
  onSelect: () => void
}

const Card = styled(Box)<{ isSelected: boolean }>`
  background-color: ${({ theme }) => theme.colors.backgroundAlt};
  border: 2px solid
    ${({ theme, isSelected }) =>
      isSelected ? theme.colors.primary : theme.isDark ? '#3a3b42' : theme.colors.background};
  width: 100%;
  border-radius: 12px;
  text-align: center;
  cursor: pointer;
  color: ${({ theme, isSelected }) => (isSelected ? theme.colors.primary : theme.colors.text)};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  padding-left: 20px;

  &:nth-child(n + 2) {
    margin-left: 0;
    margin-top: 16px;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding-left: 0;

    &:nth-child(n + 2) {
      margin-left: 16px;
      margin-top: 0;
    }
  }
`

const StyledBox = styled(Box)`
  margin-left: 24px;

  ${({ theme }) => theme.mediaQueries.sm} {
    margin-left: 0;
    padding-top: 8px;
  }
`

const LockingPeriodSelect = ({ imgSrc, lockPeriod, isSelected, onSelect, pid }: LockingPeriodSelectProps) => {
  const vaultsApr = useVaultsApr()
  const apr = formatNumber(parseFloat(vaultsApr.find((pool) => pool.poolId === pid)?.apr || '0'))

  return (
    <Card isSelected={isSelected} onClick={onSelect} pt={3} pb={3}>
      <LockPeriodLogo imgSrc={imgSrc} width={42} height={42} />
      <StyledBox>
        <Text bold color="inherit">
          {formatLockPeriod(lockPeriod)}
        </Text>
        <Text small color="inherit">
          APR: {apr}%
        </Text>
      </StyledBox>
    </Card>
  )
}

export default LockingPeriodSelect
